const managementTypes = {
  GET_MANAGEMENT_TYPES: "GET_MANAGEMENT_TYPES",
  GET_MANAGEMENT_TYPES_SUCCESS: "GET_MANAGEMENT_TYPES_SUCCESS",
  GET_MANAGEMENT_TYPES_FAILED: "GET_MANAGEMENT_TYPES_FAILED",
  GET_CASE_MANAGEMENT_TYPES: "GET_CASE_MANAGEMENT_TYPES",
  GET_CASE_MANAGEMENT_TYPES_SUCCESS: "GET_CASE_MANAGEMENT_TYPES_SUCCESS",
  GET_CASE_MANAGEMENT_TYPES_FAILED: "GET_CASE_MANAGEMENT_TYPES_FAILED",
  GET_ALL_MANAGEMENTS: "GET_ALL_MANAGEMENTS",
  GET_ALL_MANAGEMENTS_SUCCESS: "GET_ALL_MANAGEMENTS_SUCCESS",
  GET_ALL_MANAGEMENTS_FAILED: "GET_ALL_MANAGEMENTS_FAILED",
  GET_CASE_MANAGEMENTS: "GET_CASE_MANAGEMENTS",
  GET_CASE_MANAGEMENTS_SUCCESS: "GET_CASE_MANAGEMENTS_SUCCESS",
  GET_CASE_MANAGEMENTS_FAILED: "GET_CASE_MANAGEMENTS_FAILED",
  RESET_ALL_MANAGEMENTS: "RESET_ALL_MANAGEMENTS",
  RESET_CASE_MANAGEMENTS: "RESET_CASE_MANAGEMENTS",
  GET_MANAGEMENT_REQUEST: "GET_MANAGEMENT_REQUEST",
  GET_MANAGEMENT_SUCCESS: "GET_MANAGEMENT_SUCCESS",
  GET_MANAGEMENT_FAILED: "GET_MANAGEMENT_FAILED",
  POST_MANAGEMENT_REQUEST: "POST_MANAGEMENT_REQUEST",
  POST_MANAGEMENT_SUCCESS: "POST_MANAGEMENT_SUCCESS",
  POST_MANAGEMENT_FAILED: "POST_MANAGEMENT_FAILED",
  POST_CASE_MANAGEMENT_REQUEST: "POST_CASE_MANAGEMENT_REQUEST",
  POST_CASE_MANAGEMENT_SUCCESS: "POST_CASE_MANAGEMENT_SUCCESS",
  POST_CASE_MANAGEMENT_FAILED: "POST_CASE_MANAGEMENT_FAILED",
  GET_CONTACT_TYPES: "GET_CONTACT_TYPES",
  GET_CONTACT_TYPES_SUCCESS: "GET_CONTACT_TYPES_SUCCESS",
  GET_CONTACT_TYPES_FAILED: "GET_CONTACT_TYPES_FAILED",
  GET_TRACKING_REQUEST: "GET_TRACKING_REQUEST",
  GET_TRACKING_SUCCESS: "GET_TRACKING_SUCCESS",
  GET_TRACKING_FAILED: "GET_TRACKING_FAILED",
  GET_SEARCH_STATE_REQUEST: "GET_SEARCH_STATE_REQUEST",
  GET_SEARCH_STATE_SUCCESS: "GET_SEARCH_STATE_SUCCESS",
  GET_SEARCH_STATE_FAILED: "GET_SEARCH_STATE_FAILED",
  GET_REASON_REQUEST: "GET_REASON_REQUEST",
  GET_REASON_SUCCESS: "GET_REASON_SUCCESS",
  GET_REASON_FAILED: "GET_REASON_FAILED",
  GET_CLOSE_REASON_REQUEST: "GET_CLOSE_REASON_REQUEST",
  GET_CLOSE_REASON_SUCCESS: "GET_CLOSE_REASON_SUCCESS",
  GET_CLOSE_REASON_FAILED: "GET_CLOSE_REASON_FAILED",
}

export { managementTypes };